// @ts-nocheck
import { apiRequest } from "../../services/apiService";
import {
  GET_APPLIED_OPPORTUNITIES_REQUEST,
  GET_APPLIED_OPPORTUNITIES_SUCCESS,
  GET_APPLIED_OPPORTUNITIES_FAIL,
  APPLY_OPPORTUNITY_REQUEST,
  APPLY_OPPORTUNITY_SUCCESS,
  APPLY_OPPORTUNITY_FAIL,
  GET_NOT_RESPONDED_OPPORTUNITIES_FAIL,
  GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS,
  GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST,
  GET_CONTRACTOR_ISSUES_REQUEST,
  GET_CONTRACTOR_ISSUES_SUCCESS,
  GET_CONTRACTOR_ISSUES_FAIL,
  GET_CONTRACTOR_EVENTS_REQUEST,
  GET_CONTRACTOR_EVENTS_SUCCESS,
  GET_CONTRACTOR_EVENTS_FAIL,
  CLEAR_CONTRACTOR_APPLIED_LIST,
  GET_ALL_OPPORTUNITIES_REQUEST,
  GET_ALL_OPPORTUNITIES_FAIL,
  GET_ALL_OPPORTUNITIES_SUCCESS,
  DECLINE_OPPORTUNITY_ANYWAY_REQUEST,
  DECLINE_OPPORTUNITY_ANYWAY_SUCCESS,
  DECLINE_OPPORTUNITY_ANYWAY_FAILURE,
} from "../constants/opportunities";

// fetch opportunities not responded
export const getNROpportunitiesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_NOT_RESPONDED_OPPORTUNITIES_REQUEST,
      payload: payload?.params?.search || "",
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getDeclinedOpportunities`,
      params: payload?.params || {},
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_NOT_RESPONDED_OPPORTUNITIES_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_NOT_RESPONDED_OPPORTUNITIES_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

// fetch opportunities applied
export const getAppOpportunitiesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_APPLIED_OPPORTUNITIES_REQUEST,
      payload: payload?.params?.search || "",
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getAppliedOpportunities`,
      params: payload?.params || null,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_APPLIED_OPPORTUNITIES_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_APPLIED_OPPORTUNITIES_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

// apply opportunity action
export const applyOpportunityAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateOpportunityResponse`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS, payload: payload?.id });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

// apply multiple opportunity action
export const applyMultipleOpportunityAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateMulOpportunitiesResponse`,
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// updateMultipleResopnse anyway
export const updateMultipleResponseAnyway = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateMulOpportunitiesResponseAnyWay`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS, payload: payload?.id });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

// get contractor issue action
export const getContractorIssuesAction = (successCallback, failureCallback) => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_CONTRACTOR_ISSUES_REQUEST });
    // FIX (#2): endpoint scopes by contractorId. It was being called with no
    // params → 400 → "Issue Resolutions" modal opened blank. Derive the id from
    // the logged-in user (the backend also derives it from the JWT now, so this
    // is reinforcement). Also dropped the deprecated `version: "v2"` (ignored by
    // apiService now and only produced a console warning).
    const contractorId = getState()?.auth?.userId;
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getAllReportedIssueOfContractor`,
      params: { contractorId },
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      // FIX: backend returns the issues array directly under `data`
      // (shape: { success, status, data: [...] }). The old code read
      // `data.data.reportedIssues`, which is undefined → reducer set
      // `issues = undefined` → modal crashed on `issues.map()` (blank/black
      // Profile page). Support both shapes and always fall back to [].
      const payloadData = response?.data?.data;
      dispatch({
        type: GET_CONTRACTOR_ISSUES_SUCCESS,
        payload: Array.isArray(payloadData)
          ? payloadData
          : payloadData?.reportedIssues ?? [],
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_CONTRACTOR_ISSUES_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

// get contractor events
export const getContractorEventsAction = ({
  params,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_CONTRACTOR_EVENTS_REQUEST, payload: params?.search });
    const { response, error } = await apiRequest({
      method: "GET",
      url: `getContractorEvents`,
      data: null,
      params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_CONTRACTOR_EVENTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_CONTRACTOR_EVENTS_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

// clear contractor applied list
export const clearContractorAppliedListAction = () => {
  return {
    type: CLEAR_CONTRACTOR_APPLIED_LIST,
  };
};

// update anyway action
export const updateResponseAnyway = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: `updateResponseAnyway`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS, payload: payload?.id });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

export const getAllOpportunitiesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: GET_ALL_OPPORTUNITIES_REQUEST,
      payload: payload?.params?.search || "",
    });
    // Escolhe endpoint baseado em payload.endpoint (passado pelo
    // ContractorAllOpportunities baseado na rota /not-responded vs
    // /applied vs /declined). Fallback: getPendingAppliedOpportunities.
    const url = payload?.endpoint || "getPendingAppliedOpportunities";
    const { response, error } = await apiRequest({
      method: "GET",
      url,
      params: payload?.params || {},
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_ALL_OPPORTUNITIES_SUCCESS,
        payload: {
          ...response?.data,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_OPPORTUNITIES_FAIL });
      if (failureCallback) failureCallback();
    }
  };
};

// decline opportunity anyway action
export const declineOpportunityAnywayAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DECLINE_OPPORTUNITY_ANYWAY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "declineScheduleForMulDatesAnyWay",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: DECLINE_OPPORTUNITY_ANYWAY_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DECLINE_OPPORTUNITY_ANYWAY_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// decline multiple opportunity action
export const declineOpportunityMultipleAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: `declineScheduleForMulDates`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS, payload: payload?.id });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};